import { Button, Container, Form, Modal } from 'react-bootstrap';
import { Logo } from '../../components/Logo/Logo';
import './Reservation.scss';
import { Redirect, useParams } from 'react-router-dom';
import { FormEvent, useReducer, useState } from 'react';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { formReducer } from '../../utils/utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faCircleNotch } from '@fortawesome/free-solid-svg-icons';

const ReservationComponent = () => {
  const { submitReservation } = useFirebase();
  const { event } = useParams<{ event?: string }>();
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [formData, setFormData] = useReducer(formReducer, {
    name: '',
    surname: '',
    company: '',
    role: '',
    email: '',
    phone: '',
  });

  const onSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    await submitReservation(event, formData);
    setSuccess(true);
    setSuccessModal(true);
  };

  if (!event || !['spain2022'].includes(event.toLowerCase())) {
    return <Redirect to={'/'} />;
  }

  return (
    <div className={'d-flex flex-column align-items-center justify-content-around p-0 py-sm-5 mb-5 mw-960 mx-sm-auto'}>
      <Container className={'d-none d-sm-flex align-items-center justify-content-around pb-4'}>
        <Logo style={{ width: '250px' }} />
        <img style={{ width: '230px' }} src={`${process.env.PUBLIC_URL}/gcomm-logo.png`} alt={'G.COMM logo'} />
      </Container>
      <Container className={'position-relative golden-border'}>
        <div className={'d-none d-sm-flex header-reservation'}>
          <img className={'h-mirror'} src={`${process.env.PUBLIC_URL}/corner-swirl.png`} alt={null} />
          <img src={`${process.env.PUBLIC_URL}/corner-swirl.png`} alt={null} />
        </div>
        <div className={'gold-gradient title-reservation'}>Born to impress</div>
        <div className={'text-container'}>
          <div className={'swirl-title-container mb-5'}>
            <img className={'d-none d-md-block swirl anchor-left h-mirror'} src={`${process.env.PUBLIC_URL}/swirl.png`} alt={null} />
            <div className={'ribbon-container'}>
              <span className={'ribbon-text'}>TOOTOR &amp; G.COMM</span>
              <img className={'ribbon'} src={`${process.env.PUBLIC_URL}/ribbon.png`} alt={null} />
            </div>
            <img className={'d-none d-md-block swirl anchor-right'} src={`${process.env.PUBLIC_URL}/swirl.png`} alt={null} />
          </div>
          <p className={'body-text px-3 px-sm-5'}>
            ¡Estamos encantados de invitarte a el evento de inauguración de la plataforma de formación odontológica TOOTOR, que por fin ha llegado a España!
            <br />
            <br />
            ¿Qué es el estilo TOOTOR? Simple, apostar siempre a lo máximo: altísima calidad para lo mejor entretenimiento. <br />
            <strong>Contraseña: nada de aburrimiento!</strong>
          </p>
          <div className={'swirl-title-container my-5'}>
            <img className={'d-none d-md-block swirl anchor-left h-mirror'} src={`${process.env.PUBLIC_URL}/swirl.png`} alt={null} />
            <div className={'ribbon-container'}>
              <span className={'ribbon-text'}>DRESS TO IMPRESS</span>
              <img className={'ribbon'} src={`${process.env.PUBLIC_URL}/ribbon.png`} alt={null} />
            </div>
            <img className={'d-none d-md-block swirl anchor-right'} src={`${process.env.PUBLIC_URL}/swirl.png`} alt={null} />
          </div>
          <p className={'body-text px-3 px-sm-5'}>
            Olvídate de todo lo que creías saber sobre la formación dental: te demostraremos que con el estilo formativo de TOOTOR y la altísima calidad de los
            videos realizados con G.Comm también los cursos clínicos pueden ser apasionantes como una serie tv.
          </p>
          <div className={'gold-gradient date-reservation'}>Jueves, 24 Marzo</div>
          <div className={'gold-gradient hour-reservation'}>21:30</div>
          <p className={'body-text px-3 px-sm-5'}>
            ¡Te esperamos en la Terraza de Oscar, en la Plaza de Pedro Zerolo 12, Hotel Room Mate Oscar, 28004, Madrid España, para una noche dedicada a la
            diversión… odontológica! ¡Entre unas tapas y una sangría podremos conocernos y te mostraremos la plataforma en el vero estilo TOOTOR!
          </p>
          <div className={'text-center my-5'}>
            <img src={`${process.env.PUBLIC_URL}/center-swirl.png`} alt={null} />
          </div>
          <p className={'body-text px-3 px-sm-5'}>
            ¡Y antes de irte… no olvides que reservamos una Golden box llena de sorpresas sólo para ti! ¿Listos para descubrir lo que hay en ella?
          </p>
        </div>
        <div className={'d-none d-sm-flex footer-reservation'}>
          <img className={'hv-mirror'} src={`${process.env.PUBLIC_URL}/corner-swirl.png`} alt={null} />
          <img className={'v-mirror'} src={`${process.env.PUBLIC_URL}/corner-swirl.png`} alt={null} />
        </div>
      </Container>

      <Container className={'mt-5'} style={{ maxWidth: '600px', marginLeft: 'auto', marginRight: 'auto' }}>
        <Form onSubmit={onSubmit}>
          <Form.Group>
            <Form.Label htmlFor={'name'}>Nombre *</Form.Label>
            <Form.Control
              id={'name'}
              name={'name'}
              className={'form-control-golden-border'}
              value={formData.name}
              onChange={(e) => setFormData({ name: 'name', value: e.target.value })}
              required
              disabled={loading}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor={'surname'}>Apellidos *</Form.Label>
            <Form.Control
              id={'surname'}
              name={'surname'}
              className={'form-control-golden-border'}
              value={formData.surname}
              onChange={(e) => setFormData({ name: 'surname', value: e.target.value })}
              required
              disabled={loading}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor={'company'}>Empresa *</Form.Label>
            <Form.Control
              id={'company'}
              name={'company'}
              className={'form-control-golden-border'}
              value={formData.company}
              onChange={(e) => setFormData({ name: 'company', value: e.target.value })}
              required
              disabled={loading}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor={'company'}>Papel en la empresa *</Form.Label>
            <Form.Control
              id={'company'}
              name={'company'}
              className={'form-control-golden-border'}
              value={formData.role}
              onChange={(e) => setFormData({ name: 'role', value: e.target.value })}
              required
              disabled={loading}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor={'email'}>Email *</Form.Label>
            <Form.Control
              id={'email'}
              name={'email'}
              className={'form-control-golden-border'}
              type={'email'}
              value={formData.email}
              onChange={(e) => setFormData({ name: 'email', value: e.target.value })}
              required
              disabled={loading}
            />
          </Form.Group>
          <Form.Group>
            <Form.Label htmlFor={'phone'}>Número de teléfono *</Form.Label>
            <Form.Control
              id={'phone'}
              name={'phone'}
              className={'form-control-golden-border'}
              type={'tel'}
              value={formData.phone}
              onChange={(e) => setFormData({ name: 'phone', value: e.target.value })}
              required
              disabled={loading}
            />
            <Form.Text>Número de teléfono con prefijo: Ej: +34 660 XX XX XX</Form.Text>
          </Form.Group>
          <Button type={'submit'} size={'lg'} variant={success ? 'success' : 'warning'} block className={'mt-4'} disabled={loading}>
            {(() => {
              if (success)
                return (
                  <>
                    <FontAwesomeIcon icon={faCheckCircle} className={'mr-2'} /> <span>¡Reserva hecha!</span>
                  </>
                );
              if (loading)
                return (
                  <>
                    <FontAwesomeIcon icon={faCircleNotch} spin={true} className={'mr-2'} /> <span>Esperar&hellip;</span>
                  </>
                );
              return <>Partecipo</>;
            })()}
          </Button>
        </Form>
      </Container>

      <Modal show={successModal} onHide={() => setSuccessModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>¡Gracias por tu reserva!</Modal.Title>
        </Modal.Header>
        <Modal.Body>¡Recibirás el correo de confirmación a la dirección indicada!</Modal.Body>
        <Modal.Footer>
          <Button variant={'secondary'} onClick={() => setSuccessModal(false)}>
            Cierra
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ReservationComponent;
